import { render, staticRenderFns } from "./AgentChatDrawer.vue?vue&type=template&id=46d95ef4&scoped=true"
import script from "./AgentChatDrawer.vue?vue&type=script&lang=js"
export * from "./AgentChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./AgentChatDrawer.vue?vue&type=style&index=0&id=46d95ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d95ef4",
  null
  
)

export default component.exports